import React from 'react';
import { Sparkles } from 'lucide-react';

interface GreetingSummaryProps {
  focusSkill: string;
}

export function GreetingSummary({ focusSkill }: GreetingSummaryProps) {
  const getTimeBasedGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="bg-background-card rounded-xl p-6 border border-gray-800">
      <div className="flex items-center space-x-2 mb-4">
        <Sparkles className="h-5 w-5 text-accent-green" />
        <h2 className="text-xl font-bold text-black">{getTimeBasedGreeting()}</h2>
      </div>
      <p className="text-black">
        Today's focus skill: <span className="font-medium">{focusSkill}</span>
      </p>
    </div>
  );
}